export default __webpack_public_path__ + "locales/ro/Settings.json?hash=deca3a881763bcb2587f3c8e2cff1fcd";